// src/hooks/useAuth.js
// Hook pour utiliser le context d'authentification - NE PAS MODIFIER

import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};